import moment from 'moment'

// eslint-disable-next-line no-undef
const LANG = App.page.lang
moment.locale('en-EN')
if (LANG === 'cn') { moment.locale('zh-cn') }
if (LANG === 'ru') { moment.locale('ru') }

export const momentFilter = (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') => {
    return isNaN(dataStr) ? moment(dataStr).format(pattern) : /*moment.unix(dataStr).utc().add(3, 'hours').format(pattern)*/moment.unix(dataStr).local().format(pattern)
}

/**
 * Change format date
 * @name numberFilter
 * @param {number|string} dataStr - number
 * @param {object} options - contains {string} locale, {string} millesimal, {decimal} millesimal
 * @returns String
 */
export const numberFilter = (dataStr, options = {}) => {
    let settings = {
        locale: LANG === 'ru' ? 'ru-RU' : 'en-EN',
        millesimal: '',
        decimal: '.'
    }
    settings = {...settings, ...options}

    let result = dataStr.toString().replace(' ', '')
    result = result.replace(new RegExp(settings.millesimal, 'g'), '')
    result = result.replace(new RegExp(`[${settings.decimal}]`, 'g'), '.')
    result = Number(result)

    if (isNaN(result)) return dataStr

    return result.toLocaleString(settings.locale)
}
